
import TechnicalReport from './TechnicalReport.vue';

export default {
  name: 'ReceptionMobile',
  components: {
    TechnicalReport,
  },
  props: {
    activity: {
      type: Object,
      default: () => {},
    },
    red: {
      type: Array,
      default: () => [],
    },
    yellow: {
      type: Array,
      default: () => [],
    },
    green: {
      type: Array,
      default: () => [],
    },
  },
};
